import React from 'react';
import {Modal} from 'react-bootstrap';
import {Trans} from 'react-i18next';
import {Link} from 'react-router-dom';
import storeUtils from '../../utils/storeUtils';
import ConfirmDialog from '../dialogs/ConfirmDialog';
import {useSelector} from 'react-redux';
import smbUtils from '../../utils/smbUtils';
import OverLayLoader from '../spinner/OverLayLoader';
import ImageMagnifier from '../imagemanifier';

const UpgradeModal4ScpV2 = ({
  show,
  setShow,
  step,
  setStep,
  update,
  loading,
  isAllAppVersionUpdated,
  countOlderAppVersions,
}) => {
  const auth = useSelector(state => state.components.auth.accountSummary);
  const {customerId} = smbUtils.customerInfo(auth);

  return (
    <>
      <Modal
        size="xl"
        show={show}
        centered={true}
        backdrop={'static'}
        enforceFocus={true}
      >
        <Modal.Header closeButton={false}>
          <Modal.Title>
            {step === 0 && (
              <Trans i18nKey="c.a.upgrade.modal.title.v2">
                New Update Available
              </Trans>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {step === 0 && (
            <>
              <div className="row">
                <div className="col-12">
                  <p>
                    <Trans i18nKey="c.a.upgrade.modal.body1.v2">
                      Skincare Pro has enhanced its skin detection technology to
                      deliver clearer and more detailed analysis results. To
                      access these improvements, please carefully review the
                      details below and click “Update Now” when ready:
                    </Trans>
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-lg-6">
                  <p>
                    <b>1.</b>{' '}
                    <Trans i18nKey="c.a.upgrade.modal.body1.item1.v2">
                      <b>New Skin Concerns and Features</b> (for Premium Plan
                      users):
                    </Trans>
                  </p>
                  <ul>
                    <li>
                      <Trans i18nKey="c.a.upgrade.modal.body1.item1.tear.trough">
                        <b>New skin concern</b>: Tear Trough
                      </Trans>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <b>
                        <Trans i18nKey="c.a.upgrade.modal.body1.item1.wrinkles">
                          Detailed facial areas for Wrinkles:
                        </Trans>
                      </b>
                      <ul>
                        <Trans i18nKey="c.a.upgrade.modal.body1.item1.wrinkles.detail">
                          <li>Forehead Lines</li>
                          <li>Glabellar Lines</li>
                          <li>Periocular Lines</li>
                          <li>Crow's Feet</li>
                          <li>Nasolabial Folds</li>
                          <li>Marionette Lines</li>
                        </Trans>
                      </ul>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      <b>
                        <Trans i18nKey="c.a.upgrade.modal.body1.item1.pore">
                          Detailed facial areas for Pore
                        </Trans>
                      </b>
                      <ul>
                        <Trans i18nKey="c.a.upgrade.modal.body1.item1.pore.detail">
                          <li>Forehead</li>
                          <li>Cheeks</li>
                          <li>Nose</li>
                        </Trans>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-lg-6">
                  <ImageMagnifier
                    imageSrc={
                      'https://plugins-media.makeupar.com/smb/story/2024-12-31/cad01577-5bff-4a1b-bca1-ae2dd8099617.jpg'
                    }
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-lg-6 d-flex justify-content-center flex-column">
                  <p>
                    <b>
                      2.{' '}
                      <Trans i18nKey="c.a.upgrade.modal.body1.item2.title">
                        Automatic Updates for Compatibility:
                      </Trans>
                    </b>
                  </p>
                  <ul>
                    <li>
                      <Trans i18nKey="c.a.upgrade.modal.body1.item2.desc1">
                        Existing recommendation rules will be automatically
                        converted to align with the upgraded detection
                        technology.
                      </Trans>
                    </li>
                    <li>
                      <Trans i18nKey="c.a.upgrade.modal.body1.item2.desc2">
                        UI configurations will be automatically published to
                        ensure proper display after the update. Please save any
                        changes to your UI settings before clicking “Update
                        Now.”
                      </Trans>
                    </li>
                  </ul>
                </div>
                <div className="col-12 col-lg-6">
                  <ImageMagnifier
                    imageSrc={
                      'https://plugins-media.makeupar.com/smb/story/2024-12-31/11af95ab-d580-4beb-bf8e-3f0836ee1e90.jpg'
                    }
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <p>
                    <b>
                      3.{' '}
                      <Trans i18nKey="c.a.upgrade.modal.body1.item3.title">
                        App Update Requirement:
                      </Trans>
                    </b>
                  </p>
                  <ul>
                    <li>
                      <Trans i18nKey="c.a.upgrade.modal.body1.item3.desc1">
                        To access the updated version of Skin Analysis, you must
                        update your app to the latest <b>version 6.28.0.</b>
                      </Trans>
                    </li>
                  </ul>
                  {isAllAppVersionUpdated ? (
                    <>
                      <i className="fa fa-check-circle kt-margin-r-10 kt-margin-l-15 text-success" />
                      <span className="text-success">
                        <Trans i18nKey="c.a.upgrade.modal.body1.item3.desc2">
                          All your devices meet the version requirement.
                        </Trans>
                      </span>
                    </>
                  ) : (
                    <>
                      <i className="flaticon-cancel kt-margin-r-10 kt-margin-l-15 text-danger" />
                      <span className="text-danger">
                        <Trans i18nKey="c.a.upgrade.modal.body1.item3.desc3">
                          You currently have {{countOlderAppVersions}} devices
                          using an older version. Visit{' '}
                          <Link
                            className="kt-link"
                            to="/general-settings/devices"
                          >
                            License Management
                          </Link>{' '}
                          for more details.
                        </Trans>
                      </span>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            {step === 0 && (
              <>
                <button
                  className="btn btn-outline-secondary kt-margin-r-10"
                  onClick={() => {
                    storeUtils.setHideUpdatedModal(customerId, 2);
                    setStep(0);
                    setShow(false);
                  }}
                >
                  <Trans i18nKey="p.p.s.view.close">Close</Trans>
                </button>
                <ConfirmDialog placement="top" confirmCallback={update}>
                  <button className="btn btn-danger">
                    <Trans i18nKey="p.p.s.view.update">Update Now</Trans>
                  </button>
                </ConfirmDialog>
              </>
            )}
            {step === 1 && (
              <button
                className="btn btn-outline-secondary"
                onClick={() => {
                  storeUtils.removeHideUpdatedModal(customerId);
                  setShow(false);
                }}
              >
                <Trans i18nKey="p.p.s.view.close">Close</Trans>
              </button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
      {loading && <OverLayLoader />}
    </>
  );
};

export default UpgradeModal4ScpV2;
